import * as React from "react";
import MuiRegularButton, { MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";
import IconSort from "components/Icons/IconSort";
import { useTranslation } from 'react-i18next';

interface IProps {
    text?: string | JSX.Element;
}

type Props = IProps & Omit<MuiRegularButtonProps, "justIcon">;

const ButtonOrderBy: React.FC<Props> = (props) => {
    const { title, text, ...rest } = props;
    const { t } = useTranslation();
    const justIcon = typeof text == "undefined" || text == null;
    return (
        <MuiRegularButton
            {...rest}
            title={title || t("Common.Buttons.OrderByTitle")}
            justIcon={justIcon}
            onClick={props.onClick}
        >
            {!justIcon && <span>{text}</span>}
            <IconSort />
        </MuiRegularButton>
    );
};

ButtonOrderBy.defaultProps = {
    color: "transparent"
};

export default ButtonOrderBy;